var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"simpleHeader"},[_c('router-link',{staticClass:"logo",attrs:{"to":{ name: 'Index' },"title":_vm.$t('Anasayfa')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }